export const TrWidthFullText = (props) => {
    const {text, isBold} = props
    if (isBold) {
        return (
            <>
                <tr><td><b><div className="text-xs md:text-lg w-full px-10">{text}</div></b></td></tr>
            </>
        );
    } else {
        return(
            <>
                <tr><td><div className="text-xs md:text-lg w-full px-10">{text}</div></td></tr>
            </> 
        )
    }
}